import { get } from '../api.js';
import { currentParams } from '../router.js';
import { esc } from '../app.js';
import { humanSize, startCountdown, downloadAndDecryptDrop } from '../utils.js';

export async function renderDropDownload(app, params) {
  const dropId = params.id;
  const { params: qp } = currentParams();
  const keyStr = qp.get('key');

  if (!dropId || !keyStr) {
    app.innerHTML = '<div class="msg msg-error">Invalid drop link</div>';
    return;
  }

  app.innerHTML = '<p class="loading">Loading drop...</p>';

  try {
    const drop = await get(`/drops/${dropId}`);

    if (drop.claimed) {
      app.innerHTML = `
        <div class="card" style="text-align:center">
          <h2>Already Claimed</h2>
          <p style="color:var(--text-dim)">This drop has been claimed and is no longer available.</p>
        </div>`;
      return;
    }

    const expiresAt = new Date(drop.expires_at);
    const sizeStr = humanSize(drop.size_bytes);

    app.innerHTML = `
      <div class="card" style="text-align:center">
        <h2>Encrypted Drop</h2>
        <p style="color:var(--text-dim);margin-bottom:1rem"><span id="drop-filename"></span> ${sizeStr}</p>
        <div class="countdown" id="countdown"></div>
        <div id="dl-msg" style="min-height:1.5em"></div>
        <div class="actions" style="justify-content:center;margin-top:1rem;flex-wrap:wrap">
          <button class="btn btn-primary" id="download-btn">Download & Decrypt</button>
          <a href="#/drop/${dropId}/claim?key=${encodeURIComponent(keyStr)}" class="btn btn-secondary">Claim to Keep</a>
        </div>
      </div>`;

    startCountdown(expiresAt);

    document.getElementById('download-btn').onclick = async () => {
      const btn = document.getElementById('download-btn');
      const msg = document.getElementById('dl-msg');
      btn.disabled = true;

      try {
        const filename = await downloadAndDecryptDrop(dropId, keyStr, msg);
        const fnEl = document.getElementById('drop-filename');
        if (fnEl) fnEl.textContent = filename;

        msg.innerHTML = '<span style="color:var(--success)">Downloaded!</span>';
        // Post-download upsell
        const upsell = document.createElement('div');
        upsell.className = 'post-download-upsell';
        upsell.innerHTML = `
          <p class="upsell-brand">Sent via <strong>BlindKeep</strong></p>
          <p class="upsell-tagline">Zero-knowledge encrypted vault</p>
          <p class="upsell-offer">1 GB&middot;month free — no card</p>
          <a href="#/login" class="btn btn-primary btn-sm">Start your vault &rarr;</a>
        `;
        const card = app.querySelector('.card');
        if (card) card.appendChild(upsell);
        btn.disabled = false;
      } catch (err) {
        msg.innerHTML = `<span style="color:var(--danger)">${esc(err.message)}</span>`;
        btn.disabled = false;
      }
    };
  } catch (err) {
    if (err.message.includes('404') || err.message.includes('Not Found')) {
      app.innerHTML = `
        <div class="card expired-upsell" style="text-align:center">
          <h2>This drop has expired</h2>
          <p style="color:var(--text-dim);margin-bottom:1rem;line-height:1.6">Drops auto-delete after 60 min. With a BlindKeep vault, shared files stay until you delete them — with view limits, revocation, and access alerts.</p>
          <div style="display:flex;flex-direction:column;gap:8px;align-items:center">
            <a href="#/login" class="btn btn-primary btn-sm" style="width:100%">Get started free &rarr;</a>
            <a href="#/drop" class="btn btn-secondary btn-sm" style="width:100%">Send a new drop &rarr;</a>
          </div>
        </div>`;
    } else {
      app.innerHTML = `<div class="msg msg-error">${esc(err.message)}</div>`;
    }
  }
}
